import { Button, Menu, MenuItem } from "@mui/material"
import FavoriteIcon from '@mui/icons-material/Favorite';
import React, { useState } from "react";
import { FavouritesContext } from "../favourites/favouritesProvider";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { LocationContext } from "../nav/pageChooser";
import { DownloadPdfModal } from "../modal/downloadPdfModal";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { TotalMarks } from "../item/totalMarks";
import { SelectedItemsContext } from "./selectedItemsProvider";
import { useContextWithGuard } from "../helpers/useContextWithGuard";

export const SelectedMenu = () => {
    const [showDownloadModal, setShowDownloadModal] = useState<boolean>(false);

    const { selectedQns, clearSelected, selectedQnsOutOf } = useContextWithGuard(SelectedItemsContext, "SelectedItemsContext");
    const { showAddToFavouritesModal: addToChosenFolder } = useContextWithGuard(FavouritesContext, "FavouritesContext");
    const { collection } = useContextWithGuard(LocationContext, "LocationContext");

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const handleSelectedMenu = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const addSelectedToAlbum = () => {
        addToChosenFolder(selectedQns);
        // setSubPage(true);
    }

    return (
        <>
            <Button sx={{ marginRight: "20px !important" }}
                variant="outlined"
                // startIcon={<Avatar sx={{ bgcolor: "white", color: "green", width: 20, height: 20 }}>
                /* <Typography sx={{ fontSize: "1rem" }}>5</Typography> */
                /* </Avatar>} */
                endIcon={<ArrowDropDownIcon />}
                onClick={handleSelectedMenu}
                aria-label="album"
                color="inherit" >
                {selectedQns.length} Selected
                <TotalMarks outOf={selectedQnsOutOf} isBottomCorner={true} />
            </Button>

            <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                keepMounted
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'left',
                }}
                open={Boolean(anchorEl)}
                onClose={() => setAnchorEl(null)}
                sx={{ margin: "10px" }}
            >
                <MenuItem>
                    <Button
                        variant="outlined"
                        startIcon={<PictureAsPdfIcon />}
                        onClick={() => { setShowDownloadModal(true) }}
                        aria-label="download"
                        color="inherit" >
                        Download as pdf
                    </Button>
                    <DownloadPdfModal
                        open={showDownloadModal}
                        setOpen={setShowDownloadModal}
                        items={selectedQns} />
                </MenuItem>

                <MenuItem>
                    <Button
                        variant="outlined"
                        startIcon={<FavoriteIcon />}
                        onClick={() => { addSelectedToAlbum(); clearSelected(); }}
                        aria-label="album"
                        color="inherit" >
                        Add to favourites
                    </Button>
                </MenuItem>
            </Menu>
        </>

    )
}